module.exports = __webpack_public_path__ + "img/vic_police_fitness_test.b9eed086.jpg";